
import {addCity, getAllCities, getCity,updateCity,searchCity,deleteCity} from "@/services/endpoints/cities";

export default {
    async addCity({commit}, payload) {
        try {
            let res = await addCity(payload);
            if (res) {
                return res.data
            } else {
                throw new Error('err')
            }
        } catch (err) {
            throw new Error(err)
        }
    },

    async deleteCity({ commit }, payload) {
        try {
            let res = await deleteCity(payload.citiesId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getAllCities({commit},payload) {
        try {
            let res = await getAllCities(payload);
            if (res) {
                commit('SET_CITIES', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async getCitiesToEdit({commit}, citiesId) {
        try {
            let res = await getCity(citiesId);
            if (res) {
                commit('SET_CITY_TO_EDIT', res.data)
                return res.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async updateCity({commit},payload) {
        try {
            let res = await updateCity(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchCity({commit}, payload) {
        try {
            let res = await searchCity(payload);
            if (res.data.data) {
                 commit('SET_CITIES', res.data.data)
                 commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async searchIssuedCity({commit}, payload) {
        try {
            let res = await searchCity(payload);
            if (res) {
                 commit('SET_ISSUED_CITIES', res.data.data)
                 commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async searchBirthCity({commit}, payload) {
        try {
            let res = await searchCity(payload);
            if (res) {
                 commit('SET_BIRTH_CITIES', res.data.data)
                 commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },

}